import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  InputAdornment,
  IconButton,
} from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'
import ExtAgApis from '../api'
import moment from 'moment'

const schema = yup.object().shape({
  comment: yup.string().required('Commentaire est requis.'),
})

export const AddComment = (props) => {
  const { record, coproprietaire_id, copro_id } = props
  const extAgsApis = new ExtAgApis()

  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      comment: '',
    },
  })

  const onSubmit = async (data) => {
    const payload = {
      ag_id: record.ag_internal_id,
      coproprietaire_id: coproprietaire_id,
      copro_id: copro_id,
      ...data,
    }
    await extAgsApis.CreateExtAgsComments(payload)
    reset()
  }

  return (
    <div style={{ padding: '5px' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: 10,
          }}
        >
          <TextField
            {...register('comment')}
            name="comment"
            fullWidth
            label="Ecrire un commentaire"
            error={errors.comment ? true : false}
            helperText={errors.comment?.message}
            variant="outlined"
            size="medium"
            style={{ flex: 1 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton type="submit" edge="end">
                    <SendIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </form>
      {record.comments &&
        record.comments.map((comment, index) => (
          <Card key={index} style={{ marginTop: '15px' }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Nom: {comment.libelle}
              </Typography>
              <Typography variant="body2" component="p">
                Commentaire: {comment.comment}
              </Typography>
              <Typography color="textSecondary">
                Le: {moment(comment.created).format('DD/MM/YYYY')}
              </Typography>
            </CardContent>
          </Card>
        ))}
    </div>
  )
}
export default AddComment
